import React, { createContext, ReactNode, useContext } from 'react';

import { ViewProductSchema } from '@app/models/products';

interface IContext {
  selectedRows: ViewProductSchema[];
  onSelectChange: (rows: ViewProductSchema[]) => void;
  resultProducts: ViewProductSchema[];
  setResultProducts: (rows: ViewProductSchema[]) => void;
}

const ProductModalContext = createContext<IContext>(null!);

function ProductModalProvider({ children }: { children: ReactNode }) {
  const [selectedRows, setSelectedRows] = React.useState<ViewProductSchema[]>([]);
  const [resultProducts, setResultProducts] = React.useState<ViewProductSchema[]>([]);

  const onSelectChange = (rows: ViewProductSchema[]) => {
    setSelectedRows(rows);
  };

  const value = {
    selectedRows,
    onSelectChange,
    resultProducts,
    setResultProducts,
  };

  return <ProductModalContext.Provider value={value}>{children}</ProductModalContext.Provider>;
}

const useProductModal = () => {
  const context = useContext(ProductModalContext);

  if (context === undefined) {
    throw new Error('useRecipientContacts must be used within a ProductModalProvider');
  }

  return context;
};

export { ProductModalContext, ProductModalProvider, useProductModal };
